export const content = {
	en: {
		logout: "Logout",
	},
	de: {
		logout: "Abmelden",
	},
};
